import React, { useState, useEffect } from 'react';
import { Modal, Progress } from 'rsuite';

export default function DownloadModal ({ show, percents }) {
    const [percent, setPercent] = useState(0);
    const status = percent === 100 ? 'success' : null;
    const color = percent === 100 ? '#52c41a' : '#3385ff';

    useEffect(() => {
        setPercent(percents);
    }, [percents]);

    return (
        <Modal
            open={show}
            size='sm'
            backdrop='static'
        >
            <Modal.Header closeButton={false}>
                <Modal.Title>Descargando</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ width: 120, marginTop: 10, marginLeft: 'auto', marginRight: 'auto' }}>
                    <Progress.Circle percent={percent} strokeColor={color} status={status} />
                </div>
            </Modal.Body>
            <Modal.Footer style={{ textAlign: 'center' }} >
                No cierre ni refresque la pestaña hasta que termine la descarga
            </Modal.Footer>
        </Modal>
    );
}
